import posthog from 'posthog-js';
import { initAnalytics } from './analytics-client';

export const initPostHog = ({
  apiKey,
  host,
}: {
  apiKey: string | undefined;
  host: string | undefined;
}): void => {
  if (!apiKey) {
    return;
  }

  posthog.init(apiKey, {
    api_host: host || 'https://us.i.posthog.com',
    autocapture: true,
    capture_exceptions: true,
    capture_pageleave: true,
    // PostHogPageTracker fires $pageview on every React Router location change.
    // Enabling capture_pageview here would double-count every navigation.
    capture_pageview: false,
    debug: process.env.NODE_ENV === 'development',
    defaults: '2026-01-30',
    disable_session_recording: true,
    enable_heatmaps: false,
  });

  initAnalytics({
    capture: (event, properties) => {
      posthog.capture(event, properties);
    },
  });
};
